import VueBusiness from "@/business/VueBusiness";

const PERMISSOES_ABAS_DOCUMENTO = {
  'PROTOCOLO_RI': {
    geral: 'AUDITOR_ABA_INFO_GERAIS_PROTOCOLO_RI',
    atos: 'AUDITOR_ABA_ATOS_REGISTRO_PROTOCOLO_RI',
    certidoes: 'AUDITOR_ABA_CERTIDOES_PROTOCOLO_RI',
  },
  'CERTIDAO_RI': {
    geral: 'AUDITOR_ABA_INFO_GERAIS_CERTIDAO_RI',
    atos: null,
    certidoes: 'AUDITOR_ABA_CERTIDOES_CERTIDAO_RI',
  },
  'PROTOCOLO_RTD': {
    geral: 'AUDITOR_ABA_INFO_GERAIS_PROTOCOLO_RTD',
    atos: 'AUDITOR_ABA_ATOS_REGISTRO_PROTOCOLO_RTD',
    certidoes: 'AUDITOR_ABA_CERTIDOES_PROTOCOLO_RTD',
  },
  'CERTIDAO_RTD': {
    geral: 'AUDITOR_ABA_INFO_GERAIS_CERTIDAO_RTD',
    atos: null,
    certidoes: 'AUDITOR_ABA_CERTIDOES_CERTIDAO_RTD',
  },
  'PROTOCOLO_RCPJ': {
    geral: 'AUDITOR_ABA_INFO_GERAIS_PROTOCOLO_RCPJ',
    atos: 'AUDITOR_ABA_ATOS_REGISTRO_PROTOCOLO_RCPJ',
    certidoes: 'AUDITOR_ABA_CERTIDOES_PROTOCOLO_RCPJ',
  },
  'CERTIDAO_RCPJ': {
    geral: 'AUDITOR_ABA_INFO_GERAIS_CERTIDAO_RCPJ',
    atos: null,
    certidoes: 'AUDITOR_ABA_CERTIDOES_CERTIDAO_RCPJ',
  },
};

export default {

  abaVisivel(permissaoAuditor) {
    const root = VueBusiness.getVueRoot();
    return !root.isAuditorOnly || root.hasAuditorPermission(permissaoAuditor);
  },

  exibirAba(permissaoAuditor, preview) {
    return !preview && this.abaVisivel(permissaoAuditor);
  },

  permissoesAbasDocumento(dominio) {
    return PERMISSOES_ABAS_DOCUMENTO[dominio] || null;
  },

}
